var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visibility-changer" },
    [
      _vm.alertMessage
        ? _c(
            "div",
            [
              _c("a-alert", {
                attrs: {
                  message: _vm.$t("whatsapp_business_api.userVisibility"),
                  description: _vm.$t(
                    "whatsapp_business_api.userVisibilityDesc"
                  ),
                  type: "info",
                  "show-icon": "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTitle
        ? _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("mail_integration_detail.visibility"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section" },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v("Kullanıcı Erişebilirliği"),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm.getIsPublic()
            ? _c("a-alert", {
                attrs: {
                  type: "info",
                  "show-icon": "",
                  message: _vm.$t("message.visibilityInfoCont"),
                },
              })
            : _c("div", { staticClass: "lines" }, [
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("message.visibleAgents"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "agents" },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "add-btn",
                          on: { click: _vm.openAgentModal },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "md-icon",
                              staticStyle: {
                                color: "#fff",
                                "padding-right": "2px",
                              },
                            },
                            [_vm._v(" add ")]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("MultipleAvatar", {
                      staticClass: "visibility-user-avatars",
                      attrs: { "id-list": _vm.cloneUserIds },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("message.visibleDepartments"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "agents" },
                  [
                    _vm._l(_vm.cloneDepartmentIds, function (id) {
                      return _c(
                        "div",
                        { key: id, staticClass: "agent" },
                        [
                          _c("Avatar", {
                            staticClass: "mr-2 visibility-avatar",
                            attrs: {
                              size: 50,
                              src: undefined,
                              username: _vm.getDepartmentTitle(
                                _vm.getDepartment(id)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end' }",
                              },
                            ],
                            staticClass: "delete-icon",
                            attrs: {
                              content: _vm.getDepartmentTitle(
                                _vm.getDepartment(id)
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteDepartment(id)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "add-btn",
                          on: { click: _vm.openDepartmentModal },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "md-icon",
                              staticStyle: {
                                color: "#fff",
                                "padding-right": "2px",
                              },
                            },
                            [_vm._v(" add ")]
                          ),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-buttons" },
            [
              _c(
                "a-button",
                {
                  staticClass: "visibility-button",
                  attrs: { type: "primary" },
                  on: { click: _vm.openAgentModal },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.editAgentVisibility"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "visibility-button",
                  attrs: { type: "primary" },
                  on: { click: _vm.openDepartmentModal },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.editDepartmentVisibility"))
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.getIsPublic()
                ? _c(
                    "a-button",
                    {
                      staticClass: "visibility-button",
                      attrs: { type: "danger" },
                      on: { click: _vm.makePublic },
                    },
                    [_vm._v("\n                Herkese Açık Yap\n            ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "section-title" }, [
          _vm._v("Kanal Sahipleri"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "section-description" }, [
          _vm._v(
            "\n            Kanal sahipleri bu kanaldaki tüm konuşmaları görüntüleme yetkisine sahiptir.\n            Görünürlük ayarlarından bağımsız olarak tüm mesajları okuyabilirler.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lines" }, [
          _c(
            "div",
            { staticClass: "agents" },
            [
              _vm._l(_vm.getOwnerIds(), function (id) {
                return _c(
                  "div",
                  { key: id, staticClass: "agent" },
                  [
                    _c("Avatar", {
                      staticClass: "mr-2 visibility-avatar",
                      attrs: {
                        size: 50,
                        src: _vm.getUser(id)
                          ? _vm.getUser(id).gravatar
                          : undefined,
                        username: _vm.getUser(id)
                          ? _vm.getUser(id).name
                          : "N/A",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "delete-icon",
                      attrs: {
                        content: _vm.getUser(id) ? _vm.getUser(id).name : "N/A",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteOwner(id)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  { staticClass: "add-btn", on: { click: _vm.openOwnerModal } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "md-icon",
                        staticStyle: { color: "#fff", "padding-right": "2px" },
                      },
                      [_vm._v(" add ")]
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-buttons" },
          [
            _c(
              "a-button",
              {
                staticClass: "visibility-button",
                attrs: { type: "primary" },
                on: { click: _vm.openOwnerModal },
              },
              [
                _vm._v(
                  "\n                Kanal Sahiplerini Düzenle\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.visibleOwnerModal
        ? _c("FormModal", {
            attrs: {
              title: "Kanal Sahibi Seç",
              subtitle: "Bu kanalın sahibi olacak temsilcileri seçin",
            },
            on: {
              cancel: function ($event) {
                _vm.visibleOwnerModal = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "pf-main" }, [
                        _c("div", { staticClass: "pr-search" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchText,
                                expression: "searchText",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t(
                                "message.searchRepresentative"
                              ),
                            },
                            domProps: { value: _vm.searchText },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.searchText = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons mx-2 pr-icon" },
                            [_vm._v(" search ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pr-items pr-item-wrapper" },
                          _vm._l(_vm.getFilteredUsers(), function (agent) {
                            return _c(
                              "div",
                              {
                                key: agent._id,
                                staticClass: "pr-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleOwner(agent._id)
                                  },
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "segment-checkbox",
                                  attrs: {
                                    checked: _vm.cloneOwnerIds.includes(
                                      agent._id
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "user-data-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "user-data" },
                                      [
                                        _c("Avatar", {
                                          staticClass: "mr-2 visibility-avatar",
                                          attrs: {
                                            size: 30,
                                            src: agent.gravatar,
                                            username: agent.name,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "metas" }, [
                                          _c(
                                            "div",
                                            { staticClass: "pr-item-name" },
                                            [_vm._v(_vm._s(agent.name))]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.getAgentDepartmentNames(
                                                    agent
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "pr-item-status",
                                        attrs: {
                                          "data-online":
                                            _vm.$_.get(_vm.user, "_id") ===
                                            agent._id
                                              ? true
                                              : agent.isOnline,
                                          "data-status":
                                            agent.status.toLowerCase(),
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "pr-item-status-circle",
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(agent.status) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "pr-confirm-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSave },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1562263248
            ),
            model: {
              value: _vm.cloneOwnerIds,
              callback: function ($$v) {
                _vm.cloneOwnerIds = $$v
              },
              expression: "cloneOwnerIds",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.visibleAgentModal
        ? _c("FormModal", {
            attrs: {
              title: _vm.$t("message.selectAgent"),
              subtitle: _vm.$t("message.selectAgentDesc"),
            },
            on: {
              cancel: function ($event) {
                _vm.visibleAgentModal = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "pf-main" }, [
                        _c("div", { staticClass: "pr-search" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchText,
                                expression: "searchText",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t(
                                "message.searchRepresentative"
                              ),
                            },
                            domProps: { value: _vm.searchText },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.searchText = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons mx-2 pr-icon" },
                            [_vm._v(" search ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pr-items pr-item-wrapper" },
                          _vm._l(_vm.getFilteredUsers(), function (agent) {
                            return _c(
                              "div",
                              {
                                key: agent._id,
                                staticClass: "pr-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleAgent(agent._id)
                                  },
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "segment-checkbox",
                                  attrs: {
                                    checked: _vm.cloneUserIds.includes(
                                      agent._id
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "user-data-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "user-data" },
                                      [
                                        _c("Avatar", {
                                          staticClass: "mr-2 visibility-avatar",
                                          attrs: {
                                            size: 30,
                                            src: agent.gravatar,
                                            username: agent.name,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "metas" }, [
                                          _c(
                                            "div",
                                            { staticClass: "pr-item-name" },
                                            [_vm._v(_vm._s(agent.name))]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.getAgentDepartmentNames(
                                                    agent
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "pr-item-status",
                                        attrs: {
                                          "data-online":
                                            _vm.$_.get(_vm.user, "_id") ===
                                            agent._id
                                              ? true
                                              : agent.isOnline,
                                          "data-status":
                                            agent.status.toLowerCase(),
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "pr-item-status-circle",
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(agent.status) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "pr-confirm-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSave },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4277385880
            ),
            model: {
              value: _vm.cloneUserIds,
              callback: function ($$v) {
                _vm.cloneUserIds = $$v
              },
              expression: "cloneUserIds",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.visibleDepartmentModal
        ? _c("FormModal", {
            attrs: {
              title: _vm.$t("message.selectDepartment"),
              subtitle: _vm.$t("message.selectDepartmentDesc"),
            },
            on: {
              cancel: function ($event) {
                _vm.visibleDepartmentModal = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "pf-main" }, [
                        _c("div", { staticClass: "pr-search" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchText,
                                expression: "searchText",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t(
                                "message.searchRepresentative"
                              ),
                            },
                            domProps: { value: _vm.searchText },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.searchText = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons mx-2 pr-icon" },
                            [_vm._v(" search ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pr-items pr-item-wrapper" },
                          _vm._l(_vm.getFilteredDepartments(), function (item) {
                            return _c(
                              "div",
                              {
                                key: item._id,
                                staticClass: "pr-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.toogleDepartment(item._id)
                                  },
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "segment-checkbox",
                                  attrs: {
                                    checked: _vm.cloneDepartmentIds.includes(
                                      item._id
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "user-data-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "user-data" },
                                      [
                                        _c("Avatar", {
                                          staticClass: "mr-2 visibility-avatar",
                                          attrs: {
                                            size: 30,
                                            src: undefined,
                                            username:
                                              item.languageContent[
                                                _vm.$i18n.locale
                                              ].name,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "metas" }, [
                                          _c(
                                            "div",
                                            { staticClass: "pr-item-name" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    item.languageContent[
                                                      _vm.$i18n.locale
                                                    ].name
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "pr-item-status" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "avatar-group" },
                                          [
                                            _vm._l(
                                              _vm.getDepartmentUsers(
                                                item._id,
                                                2
                                              ),
                                              function (user) {
                                                return _c("Avatar", {
                                                  key: user._id,
                                                  staticClass: "avatar-wrapper",
                                                  attrs: {
                                                    size: 30,
                                                    src: user.gravatar,
                                                    username: user.name,
                                                  },
                                                })
                                              }
                                            ),
                                            _vm._v(" "),
                                            _vm.getDepartmentUsers(item._id)
                                              .length > 2
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "extra avatar-wrapper",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        +" +
                                                        _vm._s(
                                                          _vm.getDepartmentUsers(
                                                            item._id,
                                                            2
                                                          ).length - 2
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "pr-confirm-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSave },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2576293054
            ),
            model: {
              value: _vm.cloneDepartmentIds,
              callback: function ($$v) {
                _vm.cloneDepartmentIds = $$v
              },
              expression: "cloneDepartmentIds",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-description" }, [
      _vm._v(
        "\n            Aşağıda belirtilen kişiler bu kanaldaki kişi ve chatları görebilir (sahiplik varsa erişemez). Bu ayar şuralarda aktif olarak rol alır:\n            "
      ),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Otomatik chat atama:")]),
          _vm._v(
            " Bu kanala gelen müşteriler buradaki gizliliğe göre atama yapılır, bu kanalara erişimi olmayanlara chat vermez"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Yönlendirme işlemleri:")]),
          _vm._v(
            " Başka bir yerden chat yönlendirme veya chat'e başka bir temsilci eklenebilmesi için buradaki ayarlarla örtüşmesi lazım, izin verilemeyen kişiye yönlendirme yapılmaz"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Müşteri/kişi listeleri:")]),
          _vm._v(
            " Gördüğünüz listeler bu ayara göre gelir, göremediğiniz kişiler varsa buradaki ayarla ilgili olabilir"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Sahiplendirme:")]),
          _vm._v(
            " Bir müşteriyi bir temsilciye sahiplendirmek isterseniz yine bu ayar sınırında yapabilirsiniz"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }